import { AdmService } from '../../services/adm.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigService } from '../../services/config.service';
import { LoggedService } from '../../services/logged.service';
import { Pais } from '../../models/pais';
import { TablasService } from '../../services/tablas.service';
import { UsuariosService } from '../../services/usuarios.service';

@Component({
  selector: 'app-selector-pais',
  templateUrl: './selector-pais.component.html'
})
export class SelectorPaisComponent implements OnInit {

  @Input()
  paisRecibido: EventEmitter<Pais> = new EventEmitter<Pais>();
  @Output()
  paisEmitido: EventEmitter<Pais> = new EventEmitter<Pais>();
  paises: Pais[] = [];

  constructor(private loggedService: LoggedService,
    private tablasService: TablasService,
    private admService:AdmService,
    private usuariosService: UsuariosService,
    private configService: ConfigService) { }


  public Etiquetas: {

    FilterPais: string;
  }

  ngOnInit() {

    this.paises = [];
    this.Etiquetas = {

      FilterPais: this.configService.etiquetas.FilterPais
    }

    if (this.loggedService.isInRole('ADM')) {
      this.admService.cPaises().subscribe((data: Pais[]) => {
        this.paises = data;
      });

    }



  }

  selectPais(pais: any) {
    if (typeof pais != 'undefined') {

      this.paisEmitido.emit(pais);
    }
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

}
